import { TOSS_APP_ORIGINS } from './toss-origin';

export const CARRYONPAN_API_ORIGIN = 'https://carryonpan.com';

/** Same-product transport only. This does not grant cookies, login or purchase rights. */
export function apiUrl(path: string, origin = typeof location === 'undefined' ? '' : location.origin): string {
  if (!path.startsWith('/api/') || path.includes('\\') || path.includes('#') || new URL(path, CARRYONPAN_API_ORIGIN).pathname !== path.split('?')[0]) throw new Error('Invalid product API path');
  return TOSS_APP_ORIGINS.some((allowed) => allowed === origin) ? CARRYONPAN_API_ORIGIN + path : path;
}

export function corsMethods(path: string): readonly string[] {
  if (['/api/healthz', '/api/readyz', '/api/config', '/api/commerce/status', '/api/entitlements/me', '/api/iap/entitlements/me'].includes(path)) return ['GET'];
  if (['/api/events', '/api/shares', '/api/iap/session/login', '/api/iap/session/logout', '/api/iap/orders/verify-and-grant', '/api/iap/orders/reconcile'].includes(path)) return ['POST'];
  if (/^\/api\/shares\/[A-Za-z0-9_-]+$/.test(path)) return ['GET', 'PUT', 'DELETE'];
  return [];
}

export const CORS_REQUEST_HEADERS = ['authorization', 'content-type', 'if-match', 'x-carryonpan-edit-token'] as const;
